import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { toast, Bounce } from "react-toastify";
import "./feedback.css";
import CustomSelect from "../CustomSelect";

const AddFeedback = () => {
  const [codiceFiscale, setCodiceFiscale] = useState("");
  const [feedbackCoinvolgimento, setFeedbackCoinvolgimento] = useState(1);
  const [feedbackPartecipanti, setFeedbackPartecipanti] = useState(1);
  const [feedbackTutor, setFeedbackTutor] = useState(1);
  const [feedbackEfficacia, setFeedbackEfficacia] = useState(1);
  const [noteAggiuntive, setNoteAggiuntive] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Accedi per aggiungere un feedback!");
      navigate("/login");
    }
  }, [navigate]);

  const validateForm = () => {
    const newErrors = {};

    if (!codiceFiscale.trim()) {
      newErrors.codiceFiscale = "Il codice fiscale è obbligatorio";
    } else if (codiceFiscale.length !== 16) {
      newErrors.codiceFiscale = "Il codice fiscale deve essere di 16 caratteri";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      const payload = {
        trainerCodiceFiscale: codiceFiscale,
        feedbackCoinvolgimento,
        feedbackPartecipanti,
        feedbackTutor,
        feedbackEfficacia,
        noteAggiuntive,
      };

      const res = await api.post("/feedback", payload);
      if (res.status === 200) {
        toast.success("Feedback inviato con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        // reset fields
        setCodiceFiscale("");
        setFeedbackCoinvolgimento(1);
        setFeedbackPartecipanti(1);
        setFeedbackTutor(1);
        setFeedbackEfficacia(1);
        setNoteAggiuntive("");
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const renderRatingSelect = (value, setValue, label, icon) => (
    <div className="add-feedback-modern-field">
      <label className="add-feedback-modern-label">
        <i className={`fas ${icon}`}></i>
        {label}
      </label>
      <div className="add-feedback-modern-input-wrapper">
        <CustomSelect
          options={[1, 2, 3, 4, 5].map((n) => ({
            value: n,
            label: `${n}`,
          }))}
          value={
            value
              ? {
                  value: value,
                  label: `${value}`,
                }
              : null
          }
          onChange={(selected) => setValue(selected ? selected.value : null)}
          placeholder="Seleziona valutazione"
        />
      </div>
    </div>
  );

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="add-feedback-modern-container">
        <div className="add-feedback-modern-header">
          <div className="add-feedback-modern-title">
            <i className="fas fa-comment-dots"></i>
            Aggiungi Nuovo Feedback
          </div>
        </div>

        <div className="add-feedback-modern-card">
          <div className="add-feedback-modern-form">
            <div className="add-feedback-modern-section">
              <h3 className="add-feedback-modern-section-title">
                <i className="fas fa-user"></i>
                Informazioni docente
              </h3>

              <div className="add-feedback-modern-field">
                <label className="add-feedback-modern-label">
                  <i className="fas fa-id-card"></i>
                  Codice Fiscale docente *
                </label>
                <div className="add-feedback-modern-input-wrapper">
                  <input
                    type="text"
                    value={codiceFiscale}
                    onChange={(e) => {
                      setCodiceFiscale(e.target.value);
                      if (errors.codiceFiscale) {
                        setErrors((prev) => ({ ...prev, codiceFiscale: "" }));
                      }
                    }}
                    className={`add-feedback-modern-input codFisc ${
                      errors.codiceFiscale ? "error" : ""
                    }`}
                    placeholder="Inserisci il codice fiscale del docente"
                    maxLength={16}
                  />
                  {errors.codiceFiscale && (
                    <div className="add-feedback-modern-error">
                      <i className="fas fa-exclamation-circle"></i>
                      {errors.codiceFiscale}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="add-feedback-modern-section ">
              <h3 className="add-feedback-modern-section-title">
                <i className="fas fa-star"></i>
                Valutazioni
              </h3>

              <div className="add-feedback-modern-grid valutazioni">
                {renderRatingSelect(
                  feedbackCoinvolgimento,
                  setFeedbackCoinvolgimento,
                  "Coinvolgimento",
                  "fa-users"
                )}
                {renderRatingSelect(
                  feedbackPartecipanti,
                  setFeedbackPartecipanti,
                  "Partecipazione",
                  "fa-hand-holding-heart"
                )}
                {renderRatingSelect(
                  feedbackTutor,
                  setFeedbackTutor,
                  "Supporto Tutor",
                  "fa-chalkboard-teacher"
                )}
                {renderRatingSelect(
                  feedbackEfficacia,
                  setFeedbackEfficacia,
                  "Efficacia Modulo",
                  "fa-chart-line"
                )}
              </div>
            </div>

            <div className="add-feedback-modern-section">
              <h3 className="add-feedback-modern-section-title">
                <i className="fas fa-sticky-note"></i>
                Note Aggiuntive
              </h3>

              <div className="add-feedback-modern-field">
                <label className="add-feedback-modern-label">
                  <i className="fas fa-edit"></i>
                  Commenti Opzionali
                </label>
                <div className="add-feedback-modern-input-wrapper">
                  <textarea
                    value={noteAggiuntive}
                    onChange={(e) => setNoteAggiuntive(e.target.value)}
                    className="add-feedback-modern-textarea"
                    placeholder="Inserisci eventuali commenti aggiuntivi..."
                    rows={4}
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="add-feedback-modern-actions">
              <button
                className="add-feedback-modern-btn add-feedback-modern-btn-secondary"
                onClick={() => navigate("/docenti/available")}
                disabled={loading}
              >
                <i className="fas fa-times"></i>
                Anulla
              </button>
              <button
                className="add-feedback-modern-btn add-feedback-modern-btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Invio in corso...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane"></i>
                    Invia Feedback
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFeedback;
